import { z } from 'zod';
// CSV multi-value filter param → typed array (accepts a comma-separated string
// on the wire, a repeated param already parsed to an array, or absent →
// undefined). Promoted from the sites/assets module-private copies on the
// third consumer (the projections reads).
export function csv(item) {
    return z.preprocess((v) => (typeof v === 'string' ? v.split(',').map((s) => s.trim()).filter(Boolean) : v), z.array(item).optional());
}
// Boolean query param — strict 'true'/'false' text only. z.coerce.boolean()
// is a footgun here (any non-empty string, including 'false', coerces true).
export const queryBool = z.preprocess((v) => (v === 'true' ? true : v === 'false' ? false : v), z.boolean().optional());
/** A reference list's status filter: the values in use, or the disabled ones (`is_disabled`) — the lists of zones,
 *  clusters, site types, priorities, categories, tags, responsibilities, owners and roles filter by it. */
export const ENABLED_FILTER_STATES = ['active', 'disabled'];
